module.exports = __webpack_public_path__ + "static/media/27import-57.78875b8e.xlsx";